import React, { useState, useEffect } from 'react';
import '../css/skeleton.css';
import '../css/normalize.css';
import '../css/components.css';

function Footer() {
  const [timeStr, setTimeStr] = useState('');

  useEffect(() => {
    const updateTime = () => {
      const now = new Date();
      const time = now.toISOString().substring(11, 19) + ' UTC';
      setTimeStr(time);
    };

    updateTime();
    const interval = setInterval(updateTime, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <footer className="Footer container">
      <div className="footer-industrial-box industrial-card">
        {/* Corner Ticks */}
        <div className="corner-tick top-left">+</div>
        <div className="corner-tick top-right">+</div>
        <div className="corner-tick bottom-left">+</div>
        <div className="corner-tick bottom-right">+</div>

        <div className="footer-grid">
          <div className="footer-col">
            <span className="mono-label">TIMESTAMP</span>
            <span className="mono-val accent-text">{timeStr || '18:25:00 UTC'}</span>
          </div>

          <div className="footer-col">
            <span className="mono-label">SYSTEM_VER</span>
            <span className="mono-val">v2.4.0</span>
          </div>

          <div className="footer-col">
            <span className="mono-label">COORDINATES</span>
            <span className="mono-val">40.7128° N, 74.0060° W</span>
          </div>
        </div>

        <div className="footer-bottom-line">
          <p>
            &ldquo;DESIGNED & DEVELOPED BY {' '}
            <span className="brand-highlight">BELLE IT, INC</span>
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
